<template>
    {{ formatted[price] }} <span :class="compareNumber(percent)">{{ formatted[percent] }}</span>
    <div class="text-xs">on&nbsp;{{ formatted[date] }}</div>
</template>

<script setup>
const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
    price: String,
    percent: String,
    date: String,
});

const compareNumber = (field) => {
    if (props.raw[field] > 0) {
        return 'text-up';
    } else if (props.raw[field] < 0) {
        return 'text-down';
    } else {
        return 'text-unch';
    }
};
</script>
